<template>
  <v-layout row wrap class="image-upload-table">
    <v-flex xs12 pa-0>
      <template persistent>
        <v-card flat>
          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left pl-0">Image</th>
                <th class="text-left image-type-header">Type</th>
                <th class="text-right">Action</th>
              </tr>
              </thead>
              <tbody v-if="filteredImages.length > 0">
              <tr v-for="image in filteredImages" :key="image.id">
                <td>
                  <div v-if="image.signedUrl != null">
                  <v-img :src="image.signedUrl" aspect-ratio="1" max-width="80px">
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0"
                             align="center"
                             justify="center">
                        <v-progress-circular indeterminate color="accent"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  </div>
                  <div v-else> <v-progress-circular indeterminate color="accent"></v-progress-circular></div>
                </td>
                <td class="image-type-cell">
                  <v-combobox label="Document Type"
                              :items="typeSelectList"
                              v-model="image.documentTypeId"
                              chips
                              hide-no-data
                              clearable
                              item-text="text"
                              item-value="value"
                              @change="update(image)"
                              :disabled= "isDisabled">
                    <template v-slot:selection="{ item }">
                      <v-chip>
                        {{displayName(item)}}
                      </v-chip>
                    </template>
                  </v-combobox>
                </td>
                <td class="text-right pr-0 pl-0">
                  <v-icon color="accent"
                          style="padding-right: 10px;"
                          @click="getImageLink(image)">visibility
                  </v-icon>
                  <v-icon v-if="!isDisabled" color="error"
                          @click="deleteDialogForDoc(image)">mdi-trash-can-outline
                  </v-icon>
                </td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td colspan="4" class="text-center">No {{type}}s Upload</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </template>
    </v-flex>
    <template>
      <v-row justify="center">
        <v-dialog v-model="deleteConfirmDialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline  pt-1 pr-1">
              Confirm Deletion
              <v-spacer></v-spacer>
              <v-btn icon @click="deleteConfirmDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="pb-1"> Are you sure you want to delete this Image?</v-card-text>
            <v-alert v-if="this.error !=null" color="error" dark>
              <v-icon size="20" dark>warning</v-icon>
              {{this.error}}
            </v-alert>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn outlined color="error" @click="deleteMethod(deleteDoc)">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ImageUploadTable',
  props: {
    type: {
      type: String,
      default: null
    },
    stage: {
      type: String,
      default: null
    }
  },
  data: () => ({
    deleteDoc: null,
    deleteConfirmDialog: false
  }),
  async created () {
    if (!this.task) {
      this.clearImages()
    }
    await this.loadImagesByTask({ taskId: this.task.id, size: 'tiny' })
  },
  methods: {
    ...mapActions({
      loadImagesByTask: 'image/loadImagesByTask',
      clearErrors: 'image/clearErrors',
      deleteImage: 'image/deleteImage',
      clearImages: 'image/clearImageTasks',
      imageLink: 'image/getImageLink',
      updateImage: 'image/updateImage',
      createDocumentType: 'documentType/createDocumentType',
      restoreDocumentType: 'documentType/restoreDocumentType'
    }),
    deleteDialogForDoc (item) {
      this.clearErrors()
      this.deleteConfirmDialog = true
      this.deleteDoc = item
    },
    async deleteMethod (deleteDoc) {
      await this.deleteImage(deleteDoc.id)
      if (this.error == null) {
        this.deleteConfirmDialog = false
        await this.loadImagesByTask({ taskId: this.task.id, size: 'tiny' })
      } else {
        this.deleteConfirmDialog = true
      }
    },
    async getImageLink(image) {
      await this.imageLink(image.id)
    },
    async update (image) {
      if (image.workOrderTask) {
        delete image.workOrderTask
      }

      if (image.documentType) {
        delete image.documentType
      }

      if (typeof image.documentTypeId === 'string') {
        await this.addDocType(image) // create new doc type
      } else if (typeof image.documentTypeId === 'object') {
        image.documentTypeId = image.documentTypeId.value // set doc type id to type selected
      }

      await this.updateImage(image) // update
    },
    async addDocType (image) {
      let exists = false
      let typeId = null
      let archived = false

      const newDoc = {
        name: image.documentTypeId,
        slug: this.slugify(image.documentTypeId)
      }

      this.slugs.forEach((slug) => {
        if (slug.text === newDoc.slug) {
          exists = true
          typeId = slug.value
          archived = slug.archived
        }
      })

      if (exists === false) {
        await this.createDocumentType(newDoc)
        image.documentTypeId = this.docType.id
      } else if (exists === true && archived === false) {
        image.documentTypeId = typeId
      } else {
        await this.restoreDocumentType(typeId)
        image.documentTypeId = typeId
      }
    },
    displayName (value) {
      let val = value
      if (typeof value === 'object' && value != null) {
        val = value.value
      }
      this.typeSelectList.forEach(t => {
        if (t.value === val) {
          val = t.text
        }
      })
      return val
    },
    slugify (name) {
      if (name !== undefined) {
        return name.replace(/\s+/g, '-').toLowerCase()
      }
      return name
    }
  },
  computed: {
    ...mapGetters({
      images: 'image/imagesByTask',
      error: 'image/error',
      typeSelectList: 'documentType/selectList',
      slugs: 'documentType/slugs',
      users: 'user/usersNoRoles',
      id: 'user/id',
      url: 'image/imageURL',
      task: 'workOrderTask/selectedTask',
      docType: 'documentType/documentType',
      userRole: 'user/role'
    }),
    filteredImages () {
      return this.images.filter((image) => {
        if (this.displayName(image.documentTypeId) === this.type) {
          return image
        }
      })
    },
    isDisabled () {
      if (this.userRole === 'Sub Foreman' && this.stage !== 'Execution') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
@media only screen and (max-width: 550px) {
  .image-type-header,
  .image-type-cell {
    display: none;
  }
}
</style>
